import { FlowOutputStep } from '../types/FlowOutputStep';
import { IDataConnection } from '../types/IDataConnection';
import { IDataSource } from '../types/IDataSource';
import { IProject } from '../types/IProject';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export type GetFlowOutputStepsParams = {
  readonly flowId: string;
};

export type GetFlowOutputStepsResult = IResult & {
  readonly outputSteps: ReadonlyArray<FlowOutputStep>;
  readonly dataConnections: ReadonlyArray<IDataConnection>;
  readonly datasources: ReadonlyArray<IDataSource>;
  readonly projects: ReadonlyArray<IProject>;
};

export class GetFlowOutputStepsRequest extends Request<GetFlowOutputStepsParams, GetFlowOutputStepsResult> {
  constructor(params: GetFlowOutputStepsParams) {
    super('getFlowOutputSteps', params);
  }
}
